// Feedback category vocabulary.
// Mirrors the backend whitelist in
// `backend/src/vision_deliver_intelligence/feedback/models.py::FEEDBACK_CATEGORIES` — keep
// the two lists in sync. Order here drives the dropdown order in the submit
// dialog and the row order in the admin distribution chart.
//
// TEMPLATE_TODO: adjust the feedback category vocabulary if your project
// needs different buckets (also update the backend whitelist to match).

export const FEEDBACK_CATEGORIES = [
  { value: "bug", label: "Bug" },
  { value: "new_feature", label: "New feature" },
  { value: "design", label: "Design" },
  { value: "question", label: "Question" },
  { value: "general", label: "General" },
] as const;

export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number]["value"];

export const FEEDBACK_CATEGORY_VALUES: readonly FeedbackCategory[] = FEEDBACK_CATEGORIES.map(
  (c) => c.value,
);

// Tailwind classes for the category pill — one tone per category so a
// scanning admin can map "what kind of feedback is this" at a glance without
// reading the label. Uses the J&J accent palette (maroon / blue / violet /
// orange) for the differentiated buckets and the warm neutral for the
// catch-all. Accent colors are reserved for data-viz surfaces like this one.
const GENERAL_PILL_CLASS = "bg-warm-gray-03 text-warm-gray-08 ring-1 ring-warm-gray-05/30";

export const FEEDBACK_CATEGORY_PILL_CLASSES: Record<string, string> = {
  bug: "bg-jj-maroon-05/12 text-jj-maroon-05 ring-1 ring-jj-maroon-05/20",
  new_feature: "bg-jj-blue-05/10 text-jj-blue-05 ring-1 ring-jj-blue-05/20",
  design: "bg-jj-violet-05/10 text-jj-violet-05 ring-1 ring-jj-violet-05/20",
  question: "bg-jj-orange-03/15 text-jj-orange-03 ring-1 ring-jj-orange-03/25",
  general: GENERAL_PILL_CLASS,
};

export function feedbackCategoryLabel(value: string): string {
  return FEEDBACK_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}

export function feedbackCategoryPillClass(value: string): string {
  return FEEDBACK_CATEGORY_PILL_CLASSES[value] ?? GENERAL_PILL_CLASS;
}
